<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 24 24"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M21.617 10.205c-.08-.054-.16-.072-.236-.102-.063-.025-.121-.064-.184-.077-.075-.015-.147-.005-.22-.006-.073 0-.147-.014-.218-.003-.077.013-.146.052-.218.08-.064.025-.132.037-.19.071-.077.047-.135.117-.198.18-.04.041-.093.07-.13.119-1.86 2.593-4.839 4.137-7.974 4.137s-6.114-1.544-7.968-4.128a1.165 1.165 0 0 0-1.59-.278c-.037.024-.056.061-.089.09-.045.022-.096.03-.14.058L.48 11.575a1.083 1.083 0 0 0-.269 1.54c.223.304.575.465.933.465.229 0 .46-.066.662-.205l1.11-.764c.71.819 1.511 1.544 2.396 2.139l-.67 1.073a1.085 1.085 0 0 0 .385 1.518 1.169 1.169 0 0 0 1.57-.373l.718-1.15c1.166.5 2.405.82 3.684.933v1.286c0 .612.51 1.106 1.143 1.106.632 0 1.143-.494 1.143-1.106V16.74a12.06 12.06 0 0 0 3.64-.983l.644 1.077c.212.355.596.553.991.553.194 0 .391-.046.57-.147.548-.306.735-.982.419-1.511l-.64-1.07a12.219 12.219 0 0 0 2.27-2.041l1.017.699c.2.138.432.203.66.203.357 0 .71-.161.933-.464a1.083 1.083 0 0 0-.27-1.542l-1.902-1.308z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
